module.exports = __webpack_public_path__ + "img/whatsapp.5b88d03b.svg";